/* istanbul ignore file */

import { gql } from '@apollo/client';

export const GET_PRODUCT_DETAILS_QUERY = gql`
  query getDeviceDetails($parentSKU: [String!]) {
    products(filter: { sku: { in: $parentSKU } }) {
      items {
        name
        sku
        hp_cancellation_json
        ... on BundleProduct {
          hp_model_purpose
          hp_max_days_to_return
          items {
            title
            options {
              uid
              product {
                sku
                hp_product_full_specification
                hp_specifications_json
                hp_max_rollover_pages
                thumbnail {
                  url
                }
                media_gallery {
                  url
                }
                short_description {
                  html
                }
                stock_status
                ... on SimpleProduct {
                  hp_as_low_as_price
                  hp_product_type_label
                  hp_supply_type_label
                  hp_short_config_name
                }
                ... on VirtualProduct {
                  hp_short_config_name
                  hp_pages_per_month
                  hp_product_type_label
                  hp_product_type
                  hp_contract_duration
                  price {
                    regularPrice {
                      amount {
                        value
                      }
                    }
                  }
                }
              }
              label
              hp_plan_option
            }
          }
        }
      }
    }
  }
`;
